import { Enum } from '../../utils/enums'

export const ReceiptItemStatusEnumValues = ['Received', 'Edited']
export const ReceiptItemStatus = Enum('Received', 'Edited')
